import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { AlarmSuggestionAcceptRejectActions } from '../actions/alarm-suggestion-actions';

export const UserSuggestionAcceptRejectThunks = {
    userSuggestionAcceptReject: (
        alarmId: string,
        deviceId: string,
        userComments: string,
        userSuggestion: string,
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(AlarmSuggestionAcceptRejectActions.AlarmSuggestionAcceptRejectStarted());
        const payload = await ApiRequests.getAlarmSuggAcceptReject(
            {
                alarmId,
                deviceId,
                suggestionRejectedDetails: { userComments: userComments, userSuggestion: userSuggestion },
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(AlarmSuggestionAcceptRejectActions.AlarmSuggestionAcceptRejectSucceeded());
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(
            AlarmSuggestionAcceptRejectActions.AlarmSuggestionAcceptRejectFailed(
                `${ApiRequests.extractResponseNotOkCode(payload.response)}`
            )
        );
    },
    userAcceptThunk: (
        alarmId: string,
        deviceId: string,
        authHelper: AuthHelper,
        addToast: Function,
        dataAnalyticsSuggestion?: any
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(AlarmSuggestionAcceptRejectActions.AlarmSuggestionAcceptRejectStarted());
        const payload = await ApiRequests.getAlarmSuggAcceptReject(
            {
                alarmId,
                deviceId,
                suggestionAcceptedDetails: { userComments: dataAnalyticsSuggestion, userSuggestion: '' },
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(AlarmSuggestionAcceptRejectActions.AlarmSuggestionAcceptRejectSucceeded());
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(
            AlarmSuggestionAcceptRejectActions.AlarmSuggestionAcceptRejectFailed(
                `${ApiRequests.extractResponseNotOkCode(payload.response)}`
            )
        );
    },
};
